module.exports = __webpack_public_path__ + "img/icon.a8f76c19.jpg";